<template>
  <div>
    <TicketPreview ref="preview" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import axiosAdelaService from '@/axios/axiosAdelaService'
import TicketPreview from './TicketPreview.vue'

export default {
  // type: 'ABONO' | 'AJUSTE' | cualquier otro valor (o vacío) = devolución.
  // Importante: quien use este componente debe mandar el type correcto —
  // en la pantalla de ventas, this.notas mezcla abonos/ajustes y
  // devoluciones en el mismo arreglo, así que hay que etiquetar cada uno
  // al agregarlo (ver getItemAbono / getItemDevolucion) y pasar esa
  // etiqueta aquí, en vez de dejar el type fijo o sin mandar.
  props: ['folio', 'enterprise', 'print', 'type'],
  components: {
    TicketPreview
  },
  data () {
    return {
      footer: [],
      ultimaVenta: [],
      detalles: []
    }
  },
  watch: {
    async print () {
      await this.getFooterTicket()
      if (this.type === 'AJUSTE' || this.type === 'ABONO') {
        this.getAbonoDetail(this.folio)
      } else {
        this.getDevolutionDetail(this.folio)
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    // Variante: vale por abono/ajuste — una sola línea de monto
    async getAbonoDetail (invoice) {
      this.ultimaVenta = []
      const request = {
        folio: invoice,
        enterprise_id: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getDetailVale', request)
      if (response.status === 200) {
        this.ultimaVenta = response.data.rows
        this.detalles = response.data.rows // mismo objeto, igual que en el original
        this.ultimaVenta.create_at = moment(this.ultimaVenta.create_at).format('YYYY-MM-DD')

        this.$refs.preview.mostrar(this.armarPayload())
      }
    },

    // Variante: vale por devolución de productos — lista de items
    async getDevolutionDetail (invoice) {
      this.ultimaVenta = []
      const request = {
        folio: invoice,
        id_empresa: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getDetailDevolutionTicket', request)
      if (response.status === 200) {
        this.ultimaVenta = response.data.rows
        this.detalles = response.data.detail
        this.detalles.create_at = moment(this.detalles.create_at).format('YYYY-MM-DD')

        this.$refs.preview.mostrar(this.armarPayload())
      }
    },

    armarPayload () {
      const esAbono = this.type === 'ABONO' || this.type === 'AJUSTE'

      return {
        tipo: 'vale',
        tienda: this.enterprise,
        folio: this.detalles.folio,
        codigo: this.detalles.barcode,
        cliente: `${this.detalles.client_id != null ? this.detalles.client_id : ''} ${this.detalles.fullName || this.detalles.client_name || ''}`.trim(),
        atendio: this.detalles.user_name,
        // items O abono, nunca los dos — así distingue el agente qué variante imprimir
        ...(esAbono
          ? { abono: this.ultimaVenta.amount }
          : {
            items: this.ultimaVenta.map((r) => ({
              descripcion: r.producto,
              precio: r.precio,
              descuentoPct: r.porcentaje_descuento,
              total: r.venta
            }))
          }),
        usos: (this.ultimaVenta.used || []).map((v) => ({
          concepto: `VENTA FOLIO ${v.invoice}`,
          monto: v.amount
        })),
        totalVale: esAbono ? this.ultimaVenta.amount : this.detalles.amount,
        totalUtilizado: this.detalles.amount_used,
        totalActual: this.detalles.disponible,
        fechaCreacion: this.detalles.create_at,
        fechaActualizacion: this.detalles.update_at,
        telefonos: (this.footer.phones || []).map((p) => p.phone),
        nota: this.footer.couponFooter || this.footer.texto
      }
    },

    async getFooterTicket () {
      const request = {
        enterprise_id: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getFooterTicket', request)
      if (response.status === 200) {
        this.footer = response.data
      }
    }
  }
}
</script>
